// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"dd0a3227","638":"9cccdf90"}[chunkId] + ".css";
};